const bridge = () => typeof window !== "undefined" ? window.desktopOfflinePartyBills : null;

export const listOfflinePartyBills = (restaurantId, partyId, month) => {
  const api = bridge();
  if (!api?.list) {
    throw new Error("Restart the desktop app to initialize offline Party Bills.");
  }
  return api.list({ restaurantId, partyId, month });
};
